module.exports = __webpack_public_path__ + "static/media/max-space-gray.ae32f95b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/max-space-gray.png
// module id = 2056
// module chunks = 0